import { Invoice } from "@/components/shared/icons";
import { ROUTES } from "@/constants/routes";
import { useSegments } from "@/components/hooks/use-segments";
import { useAuthState } from "@/store/auth";
import { SideNavbarListItem } from "../side-navbar-list-item";

export const SideNavbarListItemInvoice = () => {
  const segments = useSegments();
  const totalOverdueInvoice = useAuthState(
    ({ data }) => data.userInfo.billingAccount.totalOverdueInvoice,
  );
  const active = !!segments.includes(ROUTES.Profile.Children.Invoices.Root);
  return (
    <SideNavbarListItem
      title="Invoices"
      icon={Invoice}
      active={active}
      to={ROUTES.Profile.Children.Invoices.Root}
      badge={totalOverdueInvoice ? `${totalOverdueInvoice}` : undefined}
    />
  );
};
